<section class="season-detail-page">
  <app-admin-page-header
    [title]="isNew ? 'Nova Missão' : 'Missão: ' + form.name"
    subtitle="Cadastro e edição de template de missão.">
    <div header-actions>
      <button class="admin-btn admin-btn--secondary" [routerLink]="['/dashboard/missions']">
        Voltar
      </button>
    </div>
  </app-admin-page-header>

  <div class="admin-feedback admin-feedback--error" *ngIf="feedbackError">
    {{ feedbackError }}
  </div>
  <div class="admin-feedback admin-feedback--success" *ngIf="feedbackSuccess">
    {{ feedbackSuccess }}
  </div>

  <div class="admin-surface block">
    <h3>Dados do Template</h3>
    
    <div class="grid">
      <label>
        <span>Jogo *</span>
        <select class="admin-input" [(ngModel)]="form.game">
          <option value="LEAGUE_OF_LEGENDS">League of Legends</option>
          <option value="COUNTER_STRIKE">Counter-Strike</option>
        </select>
      </label>
      <label>
        <span>Nome *</span>
        <input class="admin-input" [(ngModel)]="form.name" placeholder="Ex: Vitória, First Blood..." />
      </label>
      <label>
        <span>Métrica *</span>
        <input class="admin-input" [(ngModel)]="form.metric" placeholder="Ex: victory, kills, vision_score..." />
      </label>
    </div>
    
    <label>
      <span>Descrição *</span>
      <textarea class="admin-input" rows="2" [(ngModel)]="form.description"></textarea>
    </label>

    <div class="grid grid--four">
      <label>
        <span>Tier *</span>
        <input class="admin-input" type="number" [(ngModel)]="form.tier" />
      </label>
      <label>
        <span>Multiplicador *</span>
        <input class="admin-input" type="number" step="0.01" [(ngModel)]="form.multiplier" />
      </label>
      <label class="span-2">
        <span>Query Pattern Regex (Opcional)</span>
        <input class="admin-input" [(ngModel)]="form.query" placeholder="Ex: player_won==true&&player_deaths<=5" />
      </label>
    </div>

    <div class="query-reference">
      <div class="query-reference__header">
        <div>
          <h4>Métricas disponíveis para query</h4>
          <p>
            Use operadores <code>==</code>, <code>!=</code>, <code>&gt;=</code>, <code>&lt;=</code>,
            <code>&gt;</code> e <code>&lt;</code>. Para combinar condições, separe com <code>&amp;&amp;</code>.
          </p>
        </div>
      </div>

      <div class="query-reference__table-wrap">
        <table class="admin-table query-reference__table">
          <thead>
            <tr>
              <th>Campo</th>
              <th>Jogo</th>
              <th>O que contabiliza</th>
              <th>Exemplo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let metric of queryMetricReferences">
              <td><code>{{ metric.field }}</code></td>
              <td>{{ metric.game }}</td>
              <td>{{ metric.description }}</td>
              <td><code>{{ metric.example }}</code></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="checks">
      <label>
        <input type="checkbox" [(ngModel)]="form.is_active" /> 
        Template Ativo (Aparece em novas ofertas)
      </label>
    </div>

    <div class="actions">
      <button class="admin-btn admin-btn--primary" (click)="saveMission()">
        Salvar Missão
      </button>
    </div>
  </div>
</section>
